/* Enrichissements facultatifs : le sommaire et le contenu sont rendus en Liquid. */
(() => {
  function initSearch(form) {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    form.addEventListener('submit', event => {
      const input = form.elements.q;
      input.value = input.value.trim();
      if (!input.value) {
        event.preventDefault();
        input.reportValidity();
      }
    });
  }
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const share = root.querySelector('[data-rel-share]');
    if (share && navigator.clipboard && window.isSecureContext) {
      share.hidden = false;
      share.addEventListener('click', async () => {
        const status = root.querySelector('[data-rel-share-status]');
        try {
          await navigator.clipboard.writeText(share.dataset.url);
          status.textContent = share.dataset.success;
        } catch {
          status.textContent = share.dataset.failure;
        }
      });
    }
    const links = [...root.querySelectorAll('.rel-journal__toc a')];
    const anchors = links.map(link => document.getElementById(link.hash.slice(1))).filter(Boolean);
    if (!anchors.length) return;
    let scheduled = false;
    const update = () => {
      scheduled = false;
      let active = anchors[0];
      for (const anchor of anchors) if (anchor.getBoundingClientRect().top <= 180) active = anchor;
      for (const link of links) {
        if (link.hash === `#${active.id}`) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
    };
    const onScroll = () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    const onUnload = event => {
      if (event.target.contains(root)) {
        window.removeEventListener('scroll', onScroll);
        document.removeEventListener('shopify:section:unload', onUnload);
      }
    };
    document.addEventListener('shopify:section:unload', onUnload);
    update();
  }
  document.querySelectorAll('[data-rel-journal-search]').forEach(initSearch);
  document.querySelectorAll('[data-rel-editorial]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-rel-journal-search]').forEach(initSearch);
    event.target.querySelectorAll('[data-rel-editorial]').forEach(init);
  });
})();
